import * as React from 'react';
export const changeSvg = React.forwardRef(function changeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 1a.75.75 0 1 0 0 1.5c1.757 0 3.474.883 4.547 2.47.817 1.212.997 2.864.608 4.482-.287 1.192-.868 2.304-1.655 3.141V10.25a.75.75 0 0 0-1.5 0v4c0 .414.336.75.75.75h3.75a.75.75 0 0 0 0-1.5h-1.796c.93-1.034 1.584-2.343 1.91-3.697.46-1.912.288-4.024-.824-5.672C12.443 2.137 10.263 1 8 1ZM4 5.75a.75.75 0 0 0 1.5 0v-4A.75.75 0 0 0 4.75 1H1a.75.75 0 0 0 0 1.5h1.796c-.93 1.034-1.584 2.343-1.91 3.697-.46 1.912-.288 4.024.824 5.673C3.057 13.863 5.237 15 7.5 15a.75.75 0 0 0 0-1.5c-1.757 0-3.474-.883-4.547-2.47-.817-1.212-.997-2.864-.608-4.482.287-1.192.868-2.304 1.655-3.141V5.75Z',
    }),
  );
});
changeSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var change = {
  category: 'icon',
  colorable: true,
  name: 'change',
  svg: changeSvg,
};
